import axiosInstance from './axios';

export const analyticsService = {
  getVisits: async (params = {}) => {
    const response = await axiosInstance.get('/analytics/visits', { params });
    return response.data;
  },

  getEvents: async (params = {}) => {
    const response = await axiosInstance.get('/analytics/events', { params });
    return response.data;
  },

  getOverview: async (params = {}) => {
    const response = await axiosInstance.get('/analytics/overview', { params });
    return response.data;
  },

  // Additional analytics endpoints
  getOrderStatistics: async (params = {}) => {
    const response = await axiosInstance.get('/orders/statistics', { params });
    return response.data;
  },

  getSalesStatistics: async (params = {}) => {
    const response = await axiosInstance.get('/sales/statistics', { params });
    return response.data;
  },

  getCartSummary: async (params = {}) => {
    const response = await axiosInstance.get('/cart-tracking/summary', { params });
    return response.data;
  },

  getAbandonedCarts: async (params = {}) => {
    const response = await axiosInstance.get('/cart-tracking/abandoned', { params });
    return response.data;
  },
};
